import React from "react";
import CRMInputLabelAndErrorWrapComponent from "../CRMInputLabelAndErrorWrapComponent/CRMInputLabelAndErrorWrapComponent";
import { TCRMFormInputWithoutCodec } from "./CRMFormInputTypes";
import { CRMInputCalendarComponent } from "../CRMInputCalendarComponent/CRMInputCalendarComponent";

export const CRMCalendarDateWithoutTimeFormInput: TCRMFormInputWithoutCodec<string> = (props) => 
<CRMInputLabelAndErrorWrapComponent label={props.label}>
    <CRMInputCalendarComponent
        dateType={"date"}
        value={props.model}
        onChange={(value) => props.onChange(value)}
        onPressEnterKey={() => null}
        displayError={props.displayError}
        disabled={props.disabled}
    />
</CRMInputLabelAndErrorWrapComponent>